export interface PlaceholderValues {
	consultantName?: string;
	recipientFirstName?: string;
	email?: string;
	consultantPhone?: string;
	consultantEmail?: string;
	discountLabel?: string;
	minimumSpend?: string;
	expirationDate?: string;
}

const PLACEHOLDERS: ReadonlyArray<[RegExp, keyof PlaceholderValues]> = [
	[/\[consultant-name\]/gi, "consultantName"],
	[/\[recipient-first-name\]/gi, "recipientFirstName"],
	[/\[gift-recipient-email\]/gi, "email"],
	[/\[email\]/gi, "email"],
	[/\[consultant-phone\]/gi, "consultantPhone"],
	[/\[consultant-email\]/gi, "consultantEmail"],
	[/\[discount-label\]/gi, "discountLabel"],
	[/\[minimum-spend\]/gi, "minimumSpend"],
	[/\[expiration-date\]/gi, "expirationDate"]
];

/**
 * Runs in the browser so the cached page never contains a visitor's name or
 * email. A placeholder with no value is dropped and the spacing tidied.
 */
export function applyPlaceholders(
	text: string | undefined,
	values: PlaceholderValues
): string {
	if (!text) return "";

	let result = text;
	for (const [pattern, key] of PLACEHOLDERS) {
		result = result.replace(pattern, values[key] ?? "");
	}

	return result.replace(/\s+,/g, ",").replace(/ {2,}/g, " ").trim();
}
